import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useSelectedApplication } from "@/hooks/use-selected-application";
import { AuthorityRequired, hasRole } from "@/lib/auth";
import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
  useLocation,
} from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_main-layout/_payments/payments")({
  component: () => <PaymentsComponent />,
  beforeLoad: ({ location, context }) => {
    if (
      !hasRole("VIEW_ONLY", context.authorities) &&
      !hasRole("PAY_BY_LINK", context.authorities)
    ) {
      throw redirect({
        to: "/",
      });
    }
    if (location.pathname === "/payments") {
      throw redirect({
        to: "/payments/payin",
        search: (prev) => ({
          applicationId: prev.applicationId ?? context.selectedApplicationId,
        }),
      });
    }
    return context;
  },
});

const PaymentsComponent = () => {
  const location = useLocation();
  const context = Route.useRouteContext();
  const pathname = location.pathname;
  const selectedApplication = useSelectedApplication();

  return (
    <div>
      <Tabs value={pathname.split("/").at(-1)}>
        <TabsList>
          <Link to="/payments/payin" search>
            <TabsTrigger value="payin">Pay In</TabsTrigger>
          </Link>
          {selectedApplication.hasVirtualAccountsEnabled ? (
            <AuthorityRequired
              authoritiesRequired={["GENERATE_REPORTS"]}
              authAuthorities={context.authorities}
            >
              <Link to="/payments/payout" search>
                <TabsTrigger value="payout">Pay Out</TabsTrigger>
              </Link>
            </AuthorityRequired>
          ) : null}
        </TabsList>
      </Tabs>
      <div className="mt-2">
        <Outlet />
      </div>
    </div>
  );
};
